import iconVendaRapida from 'components/Icon/images/icon-vendarapida.svg';
import vendaRecuperadaCortesia from 'components/Icon/images/venda-recuperada-cortesia.svg';
import React from 'react';

import IconMap from './IconMap';

const defaultProps = {
  width: '0',
  height: '0',
  viewBox: '0 0 24 24',
  className: 'my-icon',
  name: 'icon-default',
  paths: [
    {
      d: 'M0 0h24v24H0z',
      fill: 'none',
    },
    {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z',
    },
  ],
};

interface IProps {
  name: keyof typeof IconMap | 'icon-vendarapida' | 'icon-recuperada-cortesia';
  className?: string;
  viewBox?: string;
  width?: string;
  height?: string;
  style?: object;
  onClick?: any;
  onMouseOver?: any;
  onMouseOut?: any;
  file?: boolean;
}

const MyIcon = (props: IProps) => {
  if (props.file) {
    if (props.name === 'icon-vendarapida') {
      return <img src={iconVendaRapida} alt='Caixa de presente com um cifrão no centro em movimento para a direita' className={props.className} />;
    }

    return null;
  }

  if (props.name === 'icon-recuperada-cortesia')
    return <img src={vendaRecuperadaCortesia} alt='Caixa de presente com um cifrão no centro e uma flecha acima' className={props.className} />;

  return (
    <svg
      className={props.className}
      viewBox={IconMap[props.name] && IconMap[props.name].viewBox ? IconMap[props.name].viewBox : defaultProps.viewBox}
      onClick={props.onClick}
      style={props.style}
      onMouseOver={props.onMouseOver}
      onMouseOut={props.onMouseOut}
    >
      {(IconMap[props.name] && IconMap[props.name].paths ? IconMap[props.name].paths : defaultProps.paths).map((icon: any, index: number) => (
        <path
          key={'svg-icon-' + index}
          d={icon.d}
          fill={icon.fill ? icon.fill : ''}
          className={icon.className ? icon.className : ''}
          stroke={icon.fill}
          strokeWidth={icon.strokeWidth}
        />
      ))}
    </svg>
  );
};
export default MyIcon;
